import * as React from "react";
import PropTypes from "prop-types";

import "./styles.css";

const textToEls = text =>
  text.split("\n").map((line, i) => {
    const isBold =
      line.substring(0, 2) === "**" &&
      line.substring(line.length - 2, line.length) === "**";
    return (
      <p key={i} styleName={isBold ? "important-note" : ""}>
        {isBold ? line.substring(2, line.length - 2) : line}
      </p>
    );
  });

const TitleAndBody = ({ title, body }) => (
  <>
    <div styleName="title">{title}</div>
    <div styleName="body">{textToEls(body)}</div>
  </>
);

TitleAndBody.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired
};

export default TitleAndBody;
